import type { ProposedStatusOption, Status } from './AssignmentList';

// The submitted outcome describes pending review; otherwise the saved status wins.
export const mapProposedStatus = (
  proposedStatus: Status | null,
  actualStatus: Status | null
): ProposedStatusOption => {
  switch (actualStatus) {
    case 'draft':
      return 'Draft';
    case 'in_progress':
      return 'Assigned';
    case 'completed':
      return 'Completed';
    case 'incomplete':
      return 'Incomplete';
    case 'awaiting_review':
      if (proposedStatus === 'completed') {
        return 'Submitted Complete for Review';
      }
      if (proposedStatus === 'incomplete') {
        return 'Reported Incomplete for Review';
      }
      return null;
    default:
      return null;
  }
};
